const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export function getAutoBotMediaFilename(item) {
    if (!item) return '';
    if (item.filename) return String(item.filename).split('?')[0].split('/').pop();
    if (item.r2Key) return String(item.r2Key).split('?')[0].split('/').pop();
    if (item.url) return String(item.url).split('?')[0].split('/').pop();
    return '';
}

/** Proxy URL so browser img/video tags load via API (no JWT on media tags). */
export function getAutoBotMediaDisplayUrl(item) {
    const filename = getAutoBotMediaFilename(item);
    if (!filename) return item?.url || '';
    return `${API_BASE}/api/god-autobots/media/serve/${encodeURIComponent(filename)}`;
}
